[
  {
    "id": "ProductSummary",
    "form": "Vertical",
    "width": "full",
    "children": [
      {
        "id": "Wrapper",
        "type": "RadioButtonsField",
        "width": "half"
      },
      {
        "id": "SolvingMode"
      },
      {
        "id": "Underlyings"
      },
      {
        "id": "InitialFixingStrikeType",
        "type": "RadioButtonsField"
      }
    ]
  },
  {
    "id": "InvestmentDetails",
    "form": "Vertical",
    "width": "half",
    "children": [
      {
        "id": "NotionalAmount"
      },
      {
        "id": "Currency"
      },
      {
        "id": "RemunerationMode"
      },
      {
        "id": "UpfrontFee"
      },
      {
        "id": "TradeDate"
      },
      {
        "id": "ClosingTradeDate",
        "type": "Blank"
      },
      {
        "id": "IssueDate"
      },
      {
        "id": "IssuePricePercent"
      },
      {
        "id": "FinalValuationDate"
      },
      {
        "id": "SettlementType",
        "type": "RadioButtonsField"
      },
      {
        "id": "MaturityDate"
      },
      {
        "id": "Tenor"
      }
    ]
  },
  {
    "id": "PayoffAtMaturity",
    "form": "Vertical",
    "width": "half",
    "children": [
      {
        "id": "Strike"
      },
      {
        "id": "KiBarrierType"
      },
      {
        "id": "KiBarrier"
      }
    ]
  },
  {
    "id": "Coupon",
    "form": "Vertical",
    "width": "half",
    "children": [
      {
        "id": "CouponValue"
      },
      {
        "id": "CouponType"
      },
      {
        "id": "CouponBarrier"
      },
      {
        "id": "CouponFrequency"
      },
      {
        "id": "CouponAtRedemption",
        "width": "full"
      }
    ]
  },
  {
    "id": "EarlyRedemption",
    "form": "Vertical",
    "width": "half",
    "children": [
      {
        "id": "Callability"
      },
      {
        "id": "RecallThreshold"
      },
      {
        "id": "RecallCoupon"
      }
    ]
  },
  {
    "id": "TabContainer",
    "form": "Vertical",
    "width": "full",
    "children": [
      {
        "id": "ScheduleDatesTab",
        "form": "Vertical",
        "width": "full",
        "children": [
          {
            "id": "ScheduleDatesTopBar",
            "form": "Horizontal",
            "width": "full",
            "children": [
              {
                "id": "ScheduleDatesSettings",
                "form": "Vertical",
                "width": "full",
                "children": [
                  {
                    "id": "SettlementOffset"
                  },
                  {
                    "id": "ScheduleDrivenBy",
                    "type": "RadioButtonsField"
                  },
                  {
                    "id": "ScheduleGeneration",
                    "type": "RadioButtonsField"
                  },
                  {
                    "id": "BrokenPeriodFirst",
                    "type": "RadioButtonsField"
                  },
                  {
                    "id": "BrokenPeriodLast",
                    "type": "RadioButtonsField"
                  }
                ],
                "Direction": "TopToBottom"
              },
              {
                "id": "ValuationDatesCalendar",
                "type": "MultipleBadgeField"
              },
              {
                "id": "PaymentDatesCalendar",
                "type": "MultipleBadgeField"
              },
              {
                "id": "ScheduleDates",
                "type": "ExportGridButton"
              }
            ]
          },
          {
            "id": "ScheduleDates",
            "type": "GridWithoutPagination"
          }
        ]
      },
      {
        "id": "SwapScheduleTab",
        "form": "Vertical",
        "width": "full",
        "children": [
          {
            "id": "SwapScheduleTopBar",
            "form": "Horizontal",
            "width": "full",
            "children": [
              {
                "id": "SwapSchedule",
                "type": "ExportGridButton"
              }
            ]
          },
          {
            "id": "SwapSchedule",
            "type": "GridWithoutPagination"
          }
        ]
      },
      {
        "id": "DealSplitTab",
        "width": "full",
        "children": [
          {
            "id": "DealSplit"
          }
        ]
      }
    ]
  }
]
